import React from 'react';

import Table from 'components/Table';
import {formatDate} from 'utils/datetime';

const TerminationsTable = ({
  primaryTenant,
  tenancyPeriod,
  terminationDate,
  departureDate
}) => {
  return (
    <Table simpleTable>
      <Table.Body>
        <Table.Row>
          <Table.Cell>Tenant</Table.Cell>
          <Table.Cell> {primaryTenant.fullName}</Table.Cell>
        </Table.Row>
        <Table.Row>
          <Table.Cell>Tenancy start date</Table.Cell>
          <Table.Cell>{formatDate(tenancyPeriod.startDate)}</Table.Cell>
        </Table.Row>
        <Table.Row>
          <Table.Cell>Original tenancy end date</Table.Cell>
          <Table.Cell>{formatDate(tenancyPeriod.endDate)}</Table.Cell>
        </Table.Row>
        <Table.Row>
          <Table.Cell>License termination date</Table.Cell>
          <Table.Cell>{formatDate(terminationDate)}</Table.Cell>
        </Table.Row>
        <Table.Row>
          <Table.Cell>License departure date</Table.Cell>
          <Table.Cell>
            {(departureDate && formatDate(departureDate)) || 'N/A'}
          </Table.Cell>
        </Table.Row>
      </Table.Body>
    </Table>
  );
};

export default TerminationsTable;
